import React, {createContext} from "react";

const OrderContext = createContext({});

export default OrderContext;